module.exports = __webpack_public_path__ + "img/icon_telefon_roodie_check.dd12afa0.svg";